

import React, { useState, useCallback, useMemo } from 'react'
import styled from 'styled-components'

import { ButtonYellowLight } from '../../Button'

import useAllowanceAll from '../../../hooks/nft/useAllowanceAll'
import useDecomposition from '../../../hooks/nft/useDecomposition'
import useApproveNFT from '../../../hooks/nft/useApproveNFT'
import { stopPropagation } from '../../../utils/func'
import { NFTTYPE } from '../../../constants/bakery/nft'

const Button = styled(ButtonYellowLight)`
  border: 1px solid #E0DAD3;
  background-color: initial;
  color: ${({ theme }) => theme.bsText32};
  font-family: 'Roboto-Regular';
  height: 32px;
  margin-top: 19px;
`
export default function DecomposeBtn(
  {
    artwork, 
    gameType,
    stakesIds,
    stakesIds2,
    stakesIds_v2,
    ids
  }:
  {
    artwork: any, 
    gameType: any,
    stakesIds?: any,
    stakesIds2?: any,
    stakesIds_v2?: any,
    ids?: any
  }) {
  const [requestedApprovalDecompose, setRequestedApprovalDecompose] = useState(false)
  const isStake = useMemo(() => {
    return stakesIds.includes(artwork.tokenId) || stakesIds2.includes(artwork.tokenId) || stakesIds_v2.includes(artwork.tokenId)
  }, [artwork])

  const allowanceDecomposing = useAllowanceAll({type: NFTTYPE.COMBO})

  const { onApprove } = useApproveNFT(artwork.tokenId, gameType)
  const handleApprove = useCallback(
    async (type: string) => {
      try {
        setRequestedApprovalDecompose(true)
        const txHash = await onApprove(type)
        if (!txHash) {
          setRequestedApprovalDecompose(false)
        } else {
          setTimeout(() => {
            setRequestedApprovalDecompose(false)
          }, 10000)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [onApprove]
  )
 
  // Decompose
  const { onDecomposition } = useDecomposition(artwork.tokenId)
  const [requestedDecompose, setRequestedDecompose] = useState(false)
  const handleDecompose = useCallback(async (event) => {
    try {
      event.preventDefault()
      stopPropagation(event)
      setRequestedDecompose(true)
      const txHash = await onDecomposition()
      // user rejected tx or didn't go thru
      if (!txHash) {
        setRequestedDecompose(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onDecomposition])
  
  return(
    <>
      {
        +artwork.price || ids.includes(artwork.id) || isStake ? 
        <Button
          disabled={true}
          fontSize={14}
          width="auto"
          height={40}
          altDisabledStyle={true}
        >Decompose</Button>
        : allowanceDecomposing ? 
        <Button
          onClick={handleDecompose}
          disabled={requestedDecompose}
          fontSize={14}
          width="auto"
          height={40}
          altDisabledStyle={requestedDecompose} // show solid button while waiting
        >
          {requestedDecompose ? 'Decomposing' : 'Decompose'}
        </Button>
        :
        <Button
          onClick={handleApprove.bind(null, 'DECOMPOSE')}
          disabled={requestedApprovalDecompose}
          fontSize={14}
          width="auto"
          height={40}
          altDisabledStyle={requestedApprovalDecompose} // show solid button while waiting
        >
          {requestedApprovalDecompose ? 'Approving' : 'Decompose'}
        </Button>
      }
    </>
  )
}